/**
 * Hardcoded Phase 1 test circuit. From Phase 3 on, circuits come from the
 * parametric generator; this one exists to develop and tune the driving feel.
 *
 * Layout (y grows downward): a long bottom straight, a fast right-hand sweeper
 * climbing the right side, a top-right corner into an S (the technical section),
 * a top straight, and a narrow left side bringing the lap back onto the straight.
 *
 * Surfaces — REMINDER: a control point sets the surface of the segment that
 * STARTS at it. Grip degrades along the lap: asphalt on the start straight,
 * wet asphalt up the sweeper, dirt into the top-right corner, snow through the
 * S, ice on the top straight (a straight keeps it manageable), then dirt and
 * wet down the left side back to asphalt.
 */

import type { Track, TrackControlPoint } from './track';
import { buildTrack } from './track';

export const TEST_TRACK_POINTS: TrackControlPoint[] = [
  { x: 700, y: 1900, width: 170, surface: 'asphalt' }, // P0→P1: start/finish straight
  { x: 1700, y: 1950, width: 170, surface: 'asphalt' }, // P1→P2: end of the straight
  { x: 2600, y: 1800, width: 150, surface: 'wet' }, // P2→P3: braking zone
  { x: 3050, y: 1350, width: 130, surface: 'wet' }, // P3→P4: right-hand sweeper climb
  { x: 2950, y: 850, width: 125, surface: 'dirt' }, // P4→P5: crest
  { x: 2450, y: 600, width: 135, surface: 'dirt' }, // P5→P6: top-right corner
  { x: 1950, y: 850, width: 150, surface: 'snow' }, // P6→P7: the S section
  { x: 1500, y: 600, width: 135, surface: 'ice' }, // P7→P8: TOP STRAIGHT = ice
  { x: 950, y: 500, width: 150, surface: 'dirt' }, // P8→P9: descent to top-left corner
  { x: 450, y: 750, width: 130, surface: 'wet' }, // P9→P10: narrow left side
  { x: 300, y: 1250, width: 122, surface: 'asphalt' }, // P10→P11: back on grip
  { x: 480, y: 1650, width: 150, surface: 'asphalt' }, // P11→P0: final corner onto straight
];

export function createTestTrack(): Track {
  // Start line shifted onto the middle of the bottom straight.
  return buildTrack(TEST_TRACK_POINTS, { startOffset: 450 });
}
